import { render } from "./GoRateDuplicate.vue?vue&type=template&id=37cf83f2&ts=true"
import script from "./GoRateDuplicate.vue?vue&type=script&lang=ts"
export * from "./GoRateDuplicate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__